export default class ClonedUploadModel {
  filename!: string;

  path!: string;
}
